import { MarkAsTestEventType } from 'api/types';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory<MarkAsTestEventType>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const markAsTestAdminEventReducer = createReducer<State, Actions>(initialState, {
  [actions.markAsTestAdminEvent.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.markAsTestAdminEvent.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.markAsTestAdminEvent.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.markAsTestAdminEvent.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default markAsTestAdminEventReducer;
